export const isLocalhostEnvironment = () => window.location.hostname.includes("localhost");

export const isTestEnvironment = () =>
  isLocalhostEnvironment() || window.location.hostname.includes("test");
